import React, { useRef, useState, useEffect, ReactNode, FC } from 'react'
import './horizontal-scrollbar.scss'
import { Button } from '../../atoms/button/button'
import { ReactComponent as Left } from '../../../assets/svgs/left-scroll-arrow.svg'
import { ReactComponent as Right } from '../../../assets/svgs/right-scroll-arrow.svg'

interface HorizontalScrollerProps {
  /** The items to show inside the scrollable strip */
  children: ReactNode
  /** How many pixels to scroll when you click a button */
  scrollAmount?: number
  /** Optional inline style (e.g. { width: '800px' }) to size the visible window */
  style?: React.CSSProperties
}

const HorizontalScroller: FC<HorizontalScrollerProps> = ({
  children,
  scrollAmount = 200,
  style,
}) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [, setCanScrollLeft] = useState(false)
  const [, setCanScrollRight] = useState(false)

  // Update the disabled/enabled state of the buttons
  const updateButtons = () => {
    const el = containerRef.current
    if (!el) return
    setCanScrollLeft(el.scrollLeft > 0)
    setCanScrollRight(el.scrollLeft + el.clientWidth < el.scrollWidth)
  }

  useEffect(() => {
    const el = containerRef.current
    if (!el) return

    updateButtons()
    el.addEventListener('scroll', updateButtons)
    return () => el.removeEventListener('scroll', updateButtons)
  }, [])

  const scrollBy = (offset: number) => {
    containerRef.current?.scrollBy({ left: offset, behavior: 'smooth' })
  }

  return (
    <div className="horizontal-scroller" style={style}>
      <Button
        ButtonIcon={<Left />}
        removeDefaultCss
        ariaLabel="go-back"
        handleClick={() => scrollBy(-scrollAmount)}
        className="left-btn"
      />
      <div className="scroll-strip" ref={containerRef}>
        {children}
      </div>
      <Button
        ButtonIcon={<Right />}
        removeDefaultCss
        ariaLabel="go-back"
        className="right-btn"
        handleClick={() => scrollBy(scrollAmount)}
      />
    </div>
  )
}

export default HorizontalScroller
